import './car-compatibility-checker.scss';
import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation, Scrollbar]);

export default class CarCompatibilityChecker {
    /**
        * Class constructor *
        * @arg {object} - `carCompatEl` check for the
        * car compat checker element.
    **/
    constructor (carCompatEl) {
        if (!carCompatEl) return;
        this.carCompatEl = carCompatEl;

        this.sliderElement = this.carCompatEl.querySelector('.js-car-compat-slider');
        this.swiper;
        this.slides = this.sliderElement.querySelectorAll('.js-slide');
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.pagination = this.sliderElement.querySelector('.swiper-pagination');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');
        this.slidesToggle = this.carCompatEl.querySelectorAll('.js-car-compat-slides-toggle');
        this.sliderControls = this.sliderElement.querySelector('.js-car-compat-slider-controls');
        
        this.carDataUk = require("./cars.json");
        this.carDataIe = require("./cars-ie.json");
        this.makeSelect = this.carCompatEl.querySelector('#car-make-select');
        this.modelSelect = this.carCompatEl.querySelector('#car-model-select');
        this.variantSelect = this.carCompatEl.querySelector('#car-variant-select');
        this.currentModels = [];
        this.viewResultsBtn = this.carCompatEl.querySelector('.js-car-compat-update-results');
        this.productImageOverlay = this.carCompatEl.querySelector('.js-car-compat-products-image');
        this.productImageNoResults = this.carCompatEl.querySelector('.js-car-compat-image-no-results');
        this.selectedVehicle = false;
        this.guideToggles = this.carCompatEl.querySelectorAll('.js-car-compat-toggle-guide');
        this.guideOverlay = this.carCompatEl.querySelector('.js-car-compat-guide');
        this.guideOverlayOpen = false;
        this.productCount = this.carCompatEl.querySelector('.js-car-compat-count');

        this.carData = this.selectData();
        
        this.addEventListeners();
        this.initMakeSelectValues();
        this.initSlider();
    }

    selectData() {
        const ieHostnames = ['www.silvercrossbaby.ie', 'silvercrossadmin-ireland.myshopify.com'];
        return ieHostnames.includes(window.location.hostname) ? this.carDataIe : this.carDataUk;
    }

    addEventListeners () {
        this.viewResultsBtn.addEventListener('click', () => {
            this.filterProducts();
        })
        this.makeSelect.addEventListener('change', (e) => {
            this.handleRemoveError(this.makeSelect);
            this.updateModelSelectValues(e.target.value);
            this.showOverlayImage();
            if (this.guideOverlayOpen) {
                this.toggleGuideOverlay();
            }
        })
        this.modelSelect.addEventListener('change', (e) => {
            this.handleRemoveError(this.modelSelect);
            this.updateVariantSelectValues(e.target.value);
            this.showOverlayImage();
            if (this.guideOverlayOpen) {
                this.toggleGuideOverlay();
            }
        })
        this.variantSelect.addEventListener('change', (e) => {
            this.handleRemoveError(this.variantSelect);
            this.updateSelectedVehicle(e.target.value);
            this.showOverlayImage();
            if (this.guideOverlayOpen) {
                this.toggleGuideOverlay();
            }
        })
        this.slidesToggle.forEach(toggle => {
            toggle.addEventListener('click', (e) => {
                this.handleSliderToggle(e.target);
            })
        })
        this.guideToggles.forEach(toggle => {
            toggle.addEventListener('click', () => {
                if (!this.guideOverlayOpen) {
                    this.initGuideOverlay(toggle);
                }
                this.toggleGuideOverlay();
            })
        })
    }

    initMakeSelectValues () {
        const makeArray = [];
        
        this.makeSelect.options[0].selected = true;

        this.carData.forEach(item => {
            if (!makeArray.includes(item.Brand)) {
                makeArray.push(item.Brand);
                let opt = document.createElement('option');
                opt.value = item.Brand;
                opt.innerHTML = item.Brand;
                this.makeSelect.appendChild(opt);
            }
        })
    }

    updateModelSelectValues (currentMake) {
        this.removeOptions(this.modelSelect);
        this.removeOptions(this.variantSelect);
        this.currentModels = this.carData.filter(item => item.Brand === currentMake);
        const modelArray = [];

        this.currentModels.forEach(item => {
            if (!modelArray.includes(item.Model)) {
                modelArray.push(item.Model);
                let opt = document.createElement('option');
                opt.classList.add('js-select-option');
                opt.value = item.Model;
                opt.innerHTML = item.Model;
                this.modelSelect.appendChild(opt);
            }
        })

        if (this.modelSelect.disabled) {
            this.enableSelect(this.modelSelect);
        } else {
            this.modelSelect.options[0].selected = true;
        }

        if (!this.variantSelect.disabled) {
            this.disableSelect(this.variantSelect);
        }
    }

    updateVariantSelectValues (currentModel) {
        this.removeOptions(this.variantSelect);
        const currentVariants = this.currentModels.filter(item => item.Model === currentModel);

        currentVariants.forEach(item => {
            let opt = document.createElement('option');
            opt.classList.add('js-select-option');
            opt.value = item.Vehicle;
            opt.innerHTML = item.Vehicle;
            this.variantSelect.appendChild(opt);
        })

        if (this.variantSelect.disabled) {
            this.enableSelect(this.variantSelect);
        }

        this.variantSelect.options[0].selected = true;
    }

    updateSelectedVehicle (currentVariant) {
        this.selectedVehicle = this.currentModels.find(item => item.Vehicle === currentVariant);
    }

    enableSelect (select) {
        select.disabled = false;
        const text = select.closest('.compatability-select').querySelector('p');
        text.classList.add('text-white');
        text.classList.remove('text-[#ADADAD]');
        select.classList.remove('border-[#ADADAD]');
        select.classList.remove('text-[#ADADAD]');
        select.classList.add('text-white');
        select.classList.add('border-white');
        select.classList.add('cursor-pointer');
    }

    disableSelect (select) {
        select.disabled = true;
        const text = select.closest('.compatability-select').querySelector('p');
        text.classList.remove('text-white');
        text.classList.add('text-[#ADADAD]');
        select.classList.add('border-[#ADADAD]');
        select.classList.add('text-[#ADADAD]');
        select.classList.remove('text-white');
        select.classList.remove('border-white');
        select.classList.remove('cursor-pointer');
        select.options[0].selected = true;
    }

    filterProducts () {
        const makeValue = this.makeSelect.value;
        const modelValue = this.modelSelect.value;
        const variantValue = this.variantSelect.value;

        if (!makeValue && !this.makeSelect.classList.contains('border-red-500')) {
            this.toggleSelectError(this.makeSelect);
        }

        if (!modelValue && !this.modelSelect.classList.contains('border-red-500')) {
            this.toggleSelectError(this.modelSelect);
        }

        if (!variantValue && !this.variantSelect.classList.contains('border-red-500')) {
            this.toggleSelectError(this.variantSelect);
        }

        if (makeValue && modelValue && variantValue) {
            const vehicleProducts = this.selectedVehicle?.products;
            
            if (vehicleProducts) {
                this.productImageOverlay?.classList.add('opacity-0');
                this.productImageOverlay?.classList.add('pointer-events-none');
                if (window.innerWidth < 1024) {
                    document.getElementById('car-compat-tabs').scrollIntoView();
                }

                this.slides.forEach(slide => {
                    const vehicleProductData = vehicleProducts.find(vehicleProduct => vehicleProduct.id === parseFloat(slide.dataset.productId));
                    const hasGuideData = vehicleProductData?.guides.includes(true);
                    if (vehicleProductData && hasGuideData) {
                        slide.classList.remove('!hidden');
                    } else {
                        slide.classList.add('!hidden');
                    }
                })
            } else {
                this.productImageNoResults.classList.remove('opacity-0')
            }

            this.updateSwiper();
            this.checkSliderLength();
        }
    }

    toggleSelectError (select) {
        const text = select.closest('.compatability-select').querySelector('p');
        const errorText = select.closest('.compatability-select').querySelector('.js-car-compat-select-error');
        if (select.classList.contains('border-red-500')) {
            text.classList.remove('text-red-500');
            text.classList.add('text-white');
            select.classList.remove('border-red-500');
            select.classList.add('border-white');
            errorText.classList.add('hidden');
        } else {
            text.classList.add('text-red-500');
            text.classList.remove('text-white');
            select.classList.add('border-red-500');
            select.classList.remove('border-white');
            errorText.classList.remove('hidden');
        }
    }

    handleRemoveError (select) {
        if (select.classList.contains('border-red-500')) {
            this.toggleSelectError(select);
        }
    }

    removeOptions (select) {
        const options = select.querySelectorAll('.js-select-option');
        options.forEach(option => {
            option.remove();
        })
    }

    initSlider () {
        this.swiper = new Swiper(this.sliderElement, {
            slidesPerView: 2,
            spaceBetween: 12,
            threshold: 10,
            speed: 400,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true,
                hide: false
            },
            breakpoints: {
                768: {
                    slidesPerView: 1.7,
                    spaceBetween: 10
                }
            }
        });
        this.checkSliderLength();
    }

    handleSliderToggle (button) {
        this.slidesToggle.forEach(toggle => {
            toggle.classList.remove('active')
        });
        button.classList.add('active');

        if (button.dataset.type === 'all') {
            this.slides.forEach(slide => {
                const isVehicleProduct = this.selectedVehicle?.products.find(vehicleProduct => vehicleProduct.id === parseFloat(slide.dataset.productId));
                const hasGuideData = isVehicleProduct?.guides.includes(true);
                if (isVehicleProduct && hasGuideData && slide.classList.contains('!hidden')) {
                    slide.classList.remove('!hidden')
                }
            })
        } else {
            this.slides.forEach(slide => {
                const isVehicleProduct = this.selectedVehicle?.products.find(vehicleProduct => vehicleProduct.id === parseFloat(slide.dataset.productId));
                const hasGuideData = isVehicleProduct?.guides.includes(true);
                if (isVehicleProduct && hasGuideData && slide.hasAttribute(`data-${button.dataset.type}`)) {
                    slide.classList.remove('!hidden')
                } else {
                    slide.classList.add('!hidden')
                }
            })
        }
        this.checkSliderLength();
        this.updateSwiper();
    }

    updateSwiper () {
        this.swiper.slideTo(0);
        this.swiper.scrollbar.setTranslate(0);
        this.swiper.update()
    }

    checkSliderLength () {
        const sliderLength = Array.from(this.slides).filter(slide => !slide.classList.contains('!hidden'))?.length;
        const sliderNoResults = this.carCompatEl.querySelector('.js-car-compat-no-results');

        if ((window.innerWidth < 1024 && sliderLength < 3) || (window.innerWidth > 1023 && sliderLength < 2)) {
            this.sliderControls.classList.add('hidden');
        } else {
            this.sliderControls.classList.remove('hidden');
        }
        this.productCount.innerHTML = sliderLength;
        
        if (sliderLength === 0) {
            sliderNoResults.classList.remove('hidden');
        } else {
            sliderNoResults.classList.add('hidden');
        }
    }

    initGuideOverlay (button) {
        const productJSON = JSON.parse(button.nextSibling.nextElementSibling.textContent);
        const productID = parseFloat(button.dataset.productId);
        const guideData = this.selectedVehicle?.products.find(product => product.id === productID)?.guides;
        const title = this.carCompatEl.querySelector('.js-car-compat-guide-title');
        const image = this.carCompatEl.querySelector('.js-car-compat-guide-image');
        const shopLink = this.carCompatEl.querySelector('.js-car-compat-guide-btn');
        const price = this.carCompatEl.querySelector('.js-car-compat-guide-price');
        const carImageWrap = this.carCompatEl.querySelector('.js-car-compat-guide-seat');

        // Add content from product JSON
        title.innerHTML = productJSON.title;
        image.src = productJSON.featured_image;
        shopLink.href = `/products/${productJSON.handle}`;
        if (price) {
            price.innerHTML = (productJSON.price / 100).toFixed(2);
        }
        
        // Show/Hide icons based on cars JSON
        const blockedSeat = this.carCompatEl.querySelector('.js-car-compat-guide-seat-blocked');
        const seat1 = this.carCompatEl.querySelector('.js-car-compat-guide-seat-1');
        const seat2 = this.carCompatEl.querySelector('.js-car-compat-guide-seat-2');
        const seat3 = this.carCompatEl.querySelector('.js-car-compat-guide-seat-3');
        const seat4 = this.carCompatEl.querySelector('.js-car-compat-guide-seat-4');
        const seat5 = this.carCompatEl.querySelector('.js-car-compat-guide-seat-5');
        const seat6 = this.carCompatEl.querySelector('.js-car-compat-guide-seat-6');
        const seat7 = this.carCompatEl.querySelector('.js-car-compat-guide-seat-7');

        if (guideData) {
            carImageWrap.classList.remove('hidden')
            this.toggleIcon(seat1, guideData[0]);
            this.toggleIcon(seat2, guideData[1]);
            this.toggleIcon(seat3, guideData[2]);
            this.toggleIcon(seat4, guideData[3]);
            this.toggleIcon(seat5, guideData[4]);
            this.toggleIcon(seat6, guideData[5]);
            this.toggleIcon(seat7, guideData[6]);
        } else {
            carImageWrap.classList.add('hidden')
        }

        // Show correct car image
        const fiveDoor = this.carCompatEl.querySelector('.js-car-compat-guide-car-5');
        const sevenDoor = this.carCompatEl.querySelector('.js-car-compat-guide-car-7');

        // Update icons based on car image
        if (guideData[4] || guideData[4] == false || guideData[5] || guideData[5] == false || guideData[6] || guideData[6] == false) {
            sevenDoor.classList.remove('hidden');
            blockedSeat.classList.add('ml-6', 'medium:ml-12');
            seat1.classList.add('ml-6', 'medium:ml-12');
            seat2.classList.add('ml-6', 'medium:ml-12');
            seat3.classList.add('ml-6', 'medium:ml-12');
            seat4.classList.add('ml-6', 'medium:ml-12');
            if (!fiveDoor.classList.contains('hidden')) {
                fiveDoor.classList.add('hidden');
                seat5.classList.remove('hidden');
                seat6.classList.remove('hidden');
                seat7.classList.remove('hidden');
            }
        } else {
            fiveDoor.classList.remove('hidden');
            seat5.classList.add('hidden');
            seat6.classList.add('hidden');
            seat7.classList.add('hidden');
            if (!sevenDoor.classList.contains('hidden')) {
                sevenDoor.classList.add('hidden');
                blockedSeat.classList.remove('ml-6', 'medium:ml-12');
                seat1.classList.remove('ml-6', 'medium:ml-12');
                seat2.classList.remove('ml-6', 'medium:ml-12');
                seat3.classList.remove('ml-6', 'medium:ml-12');
                seat4.classList.remove('ml-6', 'medium:ml-12');
            }
        }
    }

    toggleGuideOverlay () {
        this.guideOverlayOpen = !this.guideOverlayOpen;
        this.guideOverlay.classList.toggle('translate-x-0');
        this.guideOverlay.classList.toggle('translate-x-full');
    }

    toggleIcon (seatEl, value) {
        if (value === null) {
            seatEl.classList.add('hidden');
        } else if (value) {
            if (seatEl.classList.contains('hidden')) {
                seatEl.classList.remove('hidden')
            }
            seatEl.querySelector('[data-icon-tick]').classList.remove('hidden');
            seatEl.querySelector('[data-icon-cross]').classList.add('hidden');
        } else {
            if (seatEl.classList.contains('hidden')) {
                seatEl.classList.remove('hidden')
            }
            seatEl.querySelector('[data-icon-cross]').classList.remove('hidden');
            seatEl.querySelector('[data-icon-tick]').classList.add('hidden');
        }
    }

    showOverlayImage () {
        // Remove no results overlay when selects changed
        this.productImageNoResults.classList.add('opacity-0');
        // Add overlay image when selects changed
        if (this.productImageOverlay?.classList.contains('opacity-0')) {
            this.productImageOverlay?.classList.remove('opacity-0');
            this.productImageOverlay?.classList.remove('pointer-events-none');
        }
    }
}
